import React from "react";
import { CheckCircleIcon } from "staysure-component-library";

import ToggleBtnLabelWrapper from "@/app/shared-components/toggle-btn-wrapper/toggle-btn-label-wrapper";

import Styles from "./person-row.module.css";
import { type OrganiserPMIDetail } from "../../../../provider/private-medical-insurance.provider";

const PersonRow = React.forwardRef<
  HTMLDivElement,
  {
    person: OrganiserPMIDetail;
    showOrganiserLabel?: boolean;
    onOptionClick: (value: boolean) => void;
    optionValues: Array<{ label: string; value: boolean }>;
    toggleBtnText: string;
    testIdPrefix: string;
  }
>(
  (
    {
      person,
      showOrganiserLabel = false,
      onOptionClick,
      optionValues,
      toggleBtnText,
      testIdPrefix,
    },
    ref
  ) => {
    return (
      <div ref={ref} className="md:flex justify-between items-center w-full">
        <div>
          <p className="font-body-font text-xs text-text-body leading-27 font-semibold">
            {person.firstName} {person.lastName}
            {showOrganiserLabel && <span> (Organiser)</span>}
            {", "}
            <span className="font-normal">{person.age}</span>
          </p>
        </div>
        <div className="flex md:min-w-[164px] md:w-[164px] w-[280px] min-w-[280px] justify-between mt-spacing-xs md:mt-0 md:ml-[10px]">
          {optionValues.map((optionValue) => (
            <ToggleBtnLabelWrapper
              key={`${testIdPrefix}-${optionValue.label}`}
              data-testid={`${testIdPrefix}-${optionValue.label.toLowerCase()}`}
              btnType="button"
              isToggleEnable={false}
              label={optionValue.label}
              className={`active:bg-interactive-secondary-default active:text-dark-text-on-primary border-[1px]
bg-surface-neutral-option-1 border-interactive-secondary-default text-text-on-primary 
md:w-[78px] w-[136px] h-size-xl rounded-lg text-2xs text-left font-body-font leading-[24px] 
py-spacing-xs px-spacing-xs hover:px-[7px] flex flex-col justify-center self-start 
hover:bg-interactive-action-hovered gap-grid-system-space-050 ${Styles.policy_togglebtn_wrapper} ${Styles.toggle_btn} ${toggleBtnText}`}
              onClick={() => onOptionClick(optionValue.value)}
              isActiveRightIcon
              activeRightIcon={<CheckCircleIcon />}
              isDefaultActive={optionValue.value === person.hasPMI}
            />
          ))}
        </div>
      </div>
    );
  }
);

PersonRow.displayName = "PersonRow";

export default PersonRow;
